import GET from "./api/GET";
import POST from "./api/POST";

export const fetchOrderReport = async (
    page = 1,
    limit = process.env.REACT_APP_PAGINATION_LIMIT || 10,
    search = "",
    startDate,
    endDate,
) => {
    const response = await GET(
        `${process.env.REACT_APP_API_ENDPOINT}merchant/report/orders?page=${page}&limit=${limit}&search=${search}&startDate=${startDate}&endDate=${endDate}`,
    );
    return response;
};

export const exportOrderReport = async (credentials) => {
    const response = await POST(
        `${process.env.REACT_APP_API_ENDPOINT}merchant/report/export-orders`,
        credentials,
        {
            responseType: "blob",
        },
    );
    return response;
};